import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ExamMode"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M18.75 17.25V19.5H5.25V12.6225L7.9425 15.3075L9 14.25L4.5 9.75L0 14.25L1.0575 15.3075L3.75 12.6225V19.5C3.75 20.3284 4.42157 21 5.25 21H18.75C19.5784 21 20.25 20.3284 20.25 19.5V17.25H18.75ZM20.25 5.25V12.1275L22.9425 9.4425L24 10.5L19.5 15L15 10.5L16.0575 9.4425L18.75 12.1275V5.25H9.75V3.75H18.75C19.5784 3.75 20.25 4.42157 20.25 5.25ZM6 7.5H3C2.17157 7.5 1.5 6.82843 1.5 6V3C1.5 2.17157 2.17157 1.5 3 1.5H6C6.82843 1.5 7.5 2.17157 7.5 3V6C7.5 6.82843 6.82843 7.5 6 7.5ZM3 3V6H6V3H3Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ExamMode.vue"]]);
